/**
 * Product urgency widgets - dynamic numbers within min/max range.
 * Randomizes on load and optionally every N seconds.
 */
(function () {
  function randomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  function initUrgency() {
    document.querySelectorAll('.product__urgency[data-urgency-dynamic]').forEach((wrapper) => {
      const purchasedEl = wrapper.querySelector('[data-urgency-purchased-text]');
      const viewersEl = wrapper.querySelector('[data-urgency-viewers-text]');
      const purchasedMin = parseInt(wrapper.dataset.urgencyPurchasedMin, 10) || 1;
      const purchasedMax = parseInt(wrapper.dataset.urgencyPurchasedMax, 10) || 10;
      const viewersMin = parseInt(wrapper.dataset.urgencyViewersMin, 10) || 1;
      const viewersMax = parseInt(wrapper.dataset.urgencyViewersMax, 10) || 15;

      function update() {
        if (purchasedEl) {
          purchasedEl.textContent = randomInt(purchasedMin, purchasedMax);
        }
        if (viewersEl) {
          viewersEl.textContent = randomInt(viewersMin, viewersMax);
        }
      }

      update();

      const interval = parseInt(wrapper.dataset.urgencyInterval, 10);
      if (interval > 0) {
        setInterval(update, interval * 1000);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUrgency);
  } else {
    initUrgency();
  }

  document.addEventListener('shopify:section:load', initUrgency);
})();
